import React from "react";
import {Paper, Theme, Button} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import {img} from "@core/utils/string";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 600,
    padding: '30px 30px 20px 30px',
    position: "relative",
    zIndex: 100,
    textAlign: 'center',
    [theme.breakpoints.down(600)]: {
      width: '95%',
      padding: '20px'
    }
  },
  img: {
    width: '90%',
    margin: '0 auto',
    display: 'block'
  },
  actions: {
    marginTop: 20
  }
}))

const ForgotPasswordError = (props: {emailOrPhone: string, back: () => void}) => {
  const classes = useStyles();
  const {t} = useTranslation();
  const header = props.emailOrPhone[0] === '+' ? t('error_forgot_pass_base_phone') : t('error_forgot_pass_base_email');
  const message = props.emailOrPhone[0] === '+' ? t('error_forgot_pass_base_phone_sub') : t('error_forgot_pass_base_email_sub');
  const messageBeforeSelection = message.split(' ').splice(0, 2).join(' ');
  const messageAfterSelection = message.split(' ').splice(2).join(' ');

  return (
    <Paper className={classNames(classes.root, 'root')}>
      <img src={img('network_error.svg')} alt="" className={classes.img}/>
      <h3 className="text-default">{header}</h3>
      <p className="subtitle">{messageBeforeSelection} <strong>{props.emailOrPhone}</strong> {messageAfterSelection}</p>
      <div className={classes.actions}>
        <Button color="secondary" onClick={props.back}>{t('try_again')}</Button>
      </div>
    </Paper>
  )
}

export default ForgotPasswordError;